
/**
 * window.localStorage 浏览器永久缓存
 */
export const localStorageCollection = {
  // 设置永久缓存
  set(key, val) {
    localStorage.setItem(key, val);
  },
  // 获取永久缓存
  get(key) {
    let json = localStorage.getItem(key);
    return json;
  },
  // 移除永久缓存
  remove(key) {
    localStorage.removeItem(key);
  },
  // 移除全部永久缓存
  clear() {
    localStorage.clear();
  },
};

/**
 * window.sessionStorage 浏览器临时缓存
 */
export const sessionStorageCollection = {
  // 设置临时缓存
  set(key, val) {
    sessionStorage.setItem(key, val);
  },
  // 获取临时缓存
  get(key) {
    let json = sessionStorage.getItem(key);
    return json;
  },
  // 移除临时缓存
  remove(key) {
    sessionStorage.removeItem(key);
  },
  // 移除全部临时缓存
  clear() {
    sessionStorage.clear();
  },
};
